import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=9b120346&"
import script from "./CardTable.vue?vue&type=script&lang=js&"
export * from "./CardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports